import { gql } from 'graphql-request'

export const RESEND_INVITATION = gql`
  mutation ResendInvitation($resendInvitationId: Float!) {
    resendInvitation(id: $resendInvitationId) {
      id
    }
  }
`
